import React from 'react'
import { ThankYouButton, PamphletPageNumber } from '../../utils/AppText'
import '../../assets/css/Thankyou.css'
const PamphletRequestComplete = () => {
    document.title = '資料請求｜法人のお客様｜メットライフ生命'
    return (
        <>
        <div className="dairiten-input-section-inputdetails" style={{ height: '800px' }}>
            <div className="card-container-inputdetails row">
                <div id="popup_container" style={{ textAlign: 'left' }}>
                <h1 className="h1Style01">お問い合わせ</h1>
                    <p className="txtC tm50 bm50">&nbsp;お問い合わせを承りました。<br></br>内容確認のうえ、担当者から回答させていただきます。</p>
                </div>
            </div>
            <div className="d-grid" style={{ justifyContent: 'center' }}>
                <a href='https://www.metlife.co.jp'><button type="button" className="btn btn-secondary">{ThankYouButton}</button></a>
            </div>
        </div >
        <div className="dairiten-input-section-inputdetails"><p className="guard_mhp">{PamphletPageNumber}</p></div>
        </>
    )
}

export default PamphletRequestComplete
